import React from 'react';
import { AssetbloxLogoSvgIcon } from '../IconProvider';

const AuthHeaderTextComponent = ({ title, desc }) => {
  return (
    <>
      <div className="mx-auto w-32 darkModeLogo">
        <AssetbloxLogoSvgIcon />
      </div>
      <h4 className="mb-3 mt-4 text-center">{title || 'NA'}</h4>
      <p className="mb-5 text-sm text-[#85919F] dark:text-slate-300 text-center">
        {desc || 'NA'}{' '}
      </p>
    </>
  );
};
export default AuthHeaderTextComponent;
